import { createFeatureSelector, createSelector } from '@ngrx/store';

import { adapter } from './reference-value-sheet.reducer';
import { RefValSheetModuleState } from '../models/reference-value-sheet.model';

const { selectAll } = adapter.getSelectors();

export const getRefValSheetModuleState = createFeatureSelector<RefValSheetModuleState>(
  'referenceValueSheetModule',
);
export const getReferenceValueSheetsState = createSelector(
  getRefValSheetModuleState,
  (state) => state.refValSheets,
);

export const getReferenceValueSheets = createSelector(getReferenceValueSheetsState, selectAll);

export const getColumnSettings = createSelector(
  getRefValSheetModuleState,
  (state) => state.columns,
);

export const getReferenceValueSheetDataSeries = createSelector(
  getRefValSheetModuleState,
  (state) => state.refValSheetDataSeries,
);

export const getReferenceValueSheetKPIResults = createSelector(
  getRefValSheetModuleState,
  (state) => state.refValSheetKPIResults,
);
